import { gql } from "@apollo/client"
import { EledoConnection, EledoUser } from "./UserQueries"
import { PuzzleRequest } from "./PuzzleRequests"
import { EledoAccount } from "./EledoAccountQueries"
import { EledoApiKeyConnection } from "./EledoConnectionQueries"

export type IdentifyData = {
  userId: string | null
  authMethods: [string] | null
}

export type IdentifyDataData = {
  identify: IdentifyData
}

export type IdentifyVars = {
  email: string
}

export type AuthenticateData = {
  user: EledoUser | null
  account: EledoAccount | null
  accounts: [EledoAccount] | null
  connection: EledoConnection | null
  level: number
  apiToken?: string
  rememberMe?: string
  roles?: string[]
  requests: PuzzleRequest[] | null
  autoCreated: boolean
}

export type AuthenticateDataData = {
  authenticate: AuthenticateData
}

export type AuthenticateVars = {
  userId?: string
  accountId?: string
  type: string
  payload: string
  rememberMe?: boolean
  create?: any
  mergeUserId?: string
  mergePassword?: string
}

export interface AuthUserCreate {
  email?: string
  emailVerified?: Boolean
  name?: string
  surname?: string
  countryCode?: string
  language?: string
  timezone?: string
  locale?: string
  source?: string
  signupTerms?: Boolean
  signupNewsletter?: Boolean
}

export const GET_IDENTIFY = gql`
  mutation identify($email: String) {
    identify(email: $email) { userId authMethods }
  }
`

export const GET_AUTHENTICATE = gql`
  mutation authenticate($userId: ObjectId, $accountId: ObjectId, $type: String, $payload: String, $rememberMe: Boolean, $create: AuthUserCreate, $mergeUserId: ObjectId, $mergePassword: String) {
    authenticate(userId: $userId, accountId: $accountId, type: $type, payload: $payload, rememberMe: $rememberMe, create: $create, mergeUserId: $mergeUserId, mergePassword: $mergePassword) { user { id email name surname }
      account { id name locale timezone language countryCode } accounts { id name } connection { id updated status }
      level apiToken rememberMe roles requests { id structure { id name title width height } event } autoCreated }
  }
`

export interface GenerateApiKeyData {
  regenApiKey: EledoApiKeyConnection
}

export interface GenerateApiKeyVars {

}

export const GENERATE_NEW_API_KEY = gql`
  mutation regenApiKey {
    regenApiKey { id apiKey }
  }
`;


